export const NotificationTypes = {
  success: 'success',
  error: 'error',
  warning: 'warning',
  info: 'info'
};
